import { Box, Button, Typography } from '@material-ui/core'
import moment from 'moment'
import React from 'react'
import formatVehicleLabel from './formatVehicleLabel'

const ReservationSuggestions = ({ sameDestination, otherDestinations, passengerCount, busy, joiningId, onJoin }) => {
  const group = (title, trips) =>
    trips.length > 0 && (
      <Box mt={2}>
        <Typography variant='subtitle2'>{title}</Typography>
        {trips.map((trip) => (
          <Box key={trip._id} border={1} borderColor='grey.300' borderRadius={4} p={2} mt={1}>
            <Typography variant='body2'>
              <strong>{trip.destination}</strong> · {moment(trip.departureDate).format('DD/MM/YYYY')} {trip.departureTime} –{' '}
              {moment(trip.returnDate).format('DD/MM/YYYY')} {trip.returnTime}
            </Typography>
            <Typography variant='body2'>
              Rezervuesi: {trip.ownerName || '—'} · Vende të lira: {trip.availableSeats}
            </Typography>
            <Typography variant='body2'>Automjetet: {trip.vehicles.map(formatVehicleLabel).join(', ')}</Typography>
            {trip.additionalVehicles.length > 0 && (
              <Typography variant='body2'>
                Për grupin tuaj shtohen: {trip.additionalVehicles.map(formatVehicleLabel).join(', ')}.
              </Typography>
            )}
            {trip.joinUnavailableReason && (
              <Typography variant='body2' color='textSecondary'>
                {trip.joinUnavailableReason}
              </Typography>
            )}
            {onJoin && (
              <Box mt={1}>
                <Button
                  type='button'
                  variant='outlined'
                  color='primary'
                  size='small'
                  disabled={busy || !trip.canJoin}
                  onClick={() => onJoin(trip)}
                  aria-label={`Bashkohu me grupin në ${trip.destination} më ${trip.departureDate} në ${trip.departureTime}`}
                >
                  {joiningId === trip._id
                    ? 'Duke bashkuar…'
                    : trip.additionalVehicles.length
                      ? 'Shto automjet dhe bashkohu'
                      : 'Bashkohu me grupin'}
                </Button>
              </Box>
            )}
          </Box>
        ))}
      </Box>
    )

  return (
    <Box data-testid='reservation-suggestions'>
      {onJoin && (sameDestination.length > 0 || otherDestinations.length > 0) && (
        <Typography variant='body2' color='textSecondary'>
          Bashkimi përfshin ju dhe kolegët e zgjedhur ({passengerCount} pasagjerë), me lokacionin dhe orarin e udhëtimit të zgjedhur.
        </Typography>
      )}
      {group('Udhëtime për të njëjtin lokacion', sameDestination)}
      {group('Udhëtime për lokacione të tjera në këtë orar', otherDestinations)}
      {sameDestination.length === 0 && otherDestinations.length === 0 && (
        <Typography variant='body2' color='textSecondary'>
          Nuk ka udhëtime të miratuara që përputhen me këtë orar.
        </Typography>
      )}
    </Box>
  )
}

export default ReservationSuggestions
